import React, { useState, useEffect } from "react";
import { Modal, Button, Nav, NavItem, NavLink } from 'react-bootstrap';
import { Checkbox, Input, Select, TextArea } from '../../../Layout/Forms/Form'
import './Campaign.css';
import CampaignsRequests from "../CampaignsRequests";

const ModalCampaignInfo = ({ show, handleModalhide, info }) => {



    return (
        <>
            <Modal show={show} onHide={handleModalhide} dialogClassName="reset-width-modal modal-width-50" >
                <Modal.Header closeButton>
                    <Modal.Title>Campanha</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div className="row">
                        <div className="col-4">
                            <label className="fw-bold">Nome campanha</label>
                            <div>{info.campaign_name}</div>
                        </div>
                        <div className="col-4">
                            <label className="fw-bold">Tipo campanha</label>
                            <div>{info.campaign_type}</div>
                        </div>
                        <div className="col-4">
                            <label className="fw-bold">Data divulgação campanha</label>
                            <div>{info.campaign_date}</div>
                        </div>
                    </div>
                    <div className="row mt-5 mb-5">

                        <div className="col-4">
                            <label className="fw-bold">Spot</label>
                            <div>{info.venue_name}</div>
                        </div>
                        {
                            info.isEvent ?
                                (
                                    <>
                                        <div className="col-4">
                                            <label className="fw-bold">Evento</label>
                                            <div>{info.event_name} </div>
                                        </div>
                                        <div className="col-4">
                                            <label className="fw-bold">Evento</label>
                                            <div>{info.event_date}</div>
                                        </div>
                                    </>
                                )
                                : null
                        }

                    </div>
                    <hr />
                    <div className="row mt-3">
                        <h5 className="mb-3">Filtros</h5>
                        <div className="col-3">
                            <label className="fw-bold">Idade</label>
                            <div>{info.filters?.age.start} - {info.filters?.age.end}</div>
                        </div>
                        <div className="col-6">
                            <label className="fw-bold">Género</label>
                            <div className="col-12 mt-2">
                                <div className="row">
                                    <div className="col">
                                        <Checkbox
                                            label="Feminino"
                                            name="genero"
                                            value={[info.filters?.gender.female.toString()]}
                                            valueCK="1"
                                        />
                                    </div>
                                    <div className="col">
                                        <Checkbox
                                            label="Masculino"
                                            name="genero"
                                            value={[info.filters?.gender.male.toString()]}
                                            valueCK="1"
                                        />
                                    </div>
                                    <div className="col">
                                        <Checkbox
                                            label="Outro"
                                            name="genero"
                                            value={[info.filters?.gender.other.toString()]}
                                            valueCK="1"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="primary" onClick={handleModalhide}>
                        Fechar
                    </Button>
                </Modal.Footer>
            </Modal>

        </>
    )
}


export default ModalCampaignInfo